import { render, staticRenderFns } from "./HMW.vue?vue&type=template&id=23c23243&scoped=true&"
import script from "./HMW.vue?vue&type=script&lang=js&"
export * from "./HMW.vue?vue&type=script&lang=js&"
import style0 from "./HMW.vue?vue&type=style&index=0&id=23c23243&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c23243",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
